// ── Add Client's first month of sessions ────────────────────────
//
// MOVED OUT OF app.js UNCHANGED (standing rule ③: extract what you touch, and
// MOVE and CHANGE are separate commits). Both branches of Add Client (the
// Stripe sale and the non-Stripe add) called this same block; they now call
// this function with the client they just created.

import * as _sessions from './sessions.js';
import { showToast } from './utils.js';

/**
 * Auto-issue the first month's session credits for in-person/hybrid clients.
 *
 * ⚠️ ONE SESSIONS SYSTEM (part 7): where the account's switch is on, the server
 * gives the month (coach-issue-session-credits) and Add Client waits for it, so
 * a month that did not arrive is said, with Try again. Where it is off, the
 * page starts its own write and does not wait, as it always did.
 * @param {any} data the new client's fields
 * @param {string|null|undefined} newClientId
 * @param {string|null|undefined} coachId
 */
export async function firstMonthAtSignUp(data, newClientId, coachId) {
  if (newClientId && (data.serviceType === 'hybrid' || data.serviceType === 'in-person')) {
    const client = { ...data, id: newClientId };
    // ⚠️ A SWITCH THAT CANNOT BE READ (review 10/12) is never "off": the client is added already, so the month is
    // "not added yet", with Try again, and nothing is written the page's old way.
    let on;
    try { on = await _sessions.sessionsLedgerOn(); }
    catch (err) { console.warn('[sessions] the switch could not be read:', err.message); offerTryAgain(client, coachId, true); return; }
    if (on) {
      try { await _sessions.autoIssueCurrentPeriod(client, coachId); }
      catch (err) { console.warn('[sessions] the first month failed:', err.message); offerTryAgain(client, coachId, true); }
      return;
    }
    _sessions.autoIssueCurrentPeriod(client, coachId).catch(err =>
      console.warn('[sessions] auto-issue failed:', err.message)
    );
  }
}

/** The first month did not arrive: say so, and offer to ask again for the same client. */
function offerTryAgain(/** @type {any} */ client, /** @type {any} */ coachId, /** @type {boolean} */ justAdded) {
  const who = client.firstName || client.name || 'This client';
  showToast(`${justAdded ? `${who} was added. Their` : `${who}'s`} first month of sessions was not added yet.`, 'warning', {
    actionLabel: 'Try again',
    duration: 5 * 60 * 1000,   // review 10/12: 9 seconds was too short to see; after it there is no other way to ask
    onAction: () => {
      _sessions.autoIssueCurrentPeriod(client, coachId).then(
        (out) => showToast(
          out && out.issued ? `${out.qty} session${out.qty === 1 ? '' : 's'} added for ${who}.`
            : out && out.alreadyIssued ? `${who}'s first month of sessions is already added.`
              : `No sessions were added for ${who}.`, 'success'),
        () => offerTryAgain(client, coachId, false),
      );
    },
  });
}
